import { createServiceClient } from "shared/welda/services/axiosClient";

const apiDiscount = createServiceClient("/marketing/discounts");

const getDiscounts = async () => await apiDiscount.get("/");

const getDiscountById = async (id) => await apiDiscount.get(`/get/${id}`);

const createDiscount = async (discount) =>
  await apiDiscount.post("/create", discount);

const updateDiscount = async (id, discount) =>
  await apiDiscount.put(`/update/${id}`, discount);

const deleteDiscount = async (id) => await apiDiscount.delete(`/delete/${id}`);

const applyDiscountCode = async ({ code }) =>
  await apiDiscount.get(`/apply/${code}`);

const removeDiscountCodeFromCart = async () =>
  await apiDiscount.post(`/remove`);

const discountService = {
  applyDiscountCode,
  removeDiscountCodeFromCart,
  getDiscounts,
  getDiscountById,
  createDiscount,
  updateDiscount,
  deleteDiscount,
};

export default discountService;
